(function () {

  const TARGET_COLLECTION_ID = '702468653425';

  const translations = {
    'nl': 'Cursussen',
    'fr': 'Cursussen',
    'en': 'Cursussen',
  };

  const collectionId = window.meta
    && window.meta.page
    && window.meta.page.resourceId;

  if (String(collectionId) !== TARGET_COLLECTION_ID) return;

  const locale = (window.Shopify && window.Shopify.locale)
    ? window.Shopify.locale.split('-')[0]
    : 'nl';

  const label = translations[locale] || translations['nl'];

  console.log('[FilterOverride] Matched. Locale:', locale, '| Label:', label);

  function patchFilterLabel() {
    // Target ALL span.h6 inside ANY vendor filter details — covers both
    // mobile drawer and desktop sidebar instances in the DOM
    const allVendorDetails = document.querySelectorAll(
      'details[data-index*="filter.p.vendor"]'
    );

    console.log('[FilterOverride] Vendor details found:', allVendorDetails.length);

    allVendorDetails.forEach(function (details, i) {
      const span = details.querySelector('summary span.h6');
      if (!span) return;

      const current = span.textContent.trim();
      console.log('[FilterOverride] Instance ' + i + ' current text:', current);

      if (current === label) return;

      console.log('[FilterOverride] Patching instance ' + i + ': "' + current + '" → "' + label + '"');
      span.textContent = label;
    });
  }

  setInterval(patchFilterLabel, 300);
  document.addEventListener('DOMContentLoaded', patchFilterLabel);
  window.addEventListener('load', patchFilterLabel);

})();
